import { ReactKeycloakProvider, useKeycloak } from "@react-keycloak/web";
import { Route, Switch } from "react-router-dom";
import { Result } from "antd";
import { useTranslation } from "react-i18next";

import HomePage from "./components/HomePage/HomePage";
import keycloak from "./keycloak";
import Login from "./components/Login/Login";
import { useDispatch } from "react-redux";
import { initialize } from "services/features/VisitsSlice";
import { useSelector } from "react-redux";

const HomeSwitch = () => {
  const { keycloak } = useKeycloak();
  return keycloak.authenticated ? <HomePage keycloak /> : <Login />;
};

const Routes = ({ token, acmConf }) => {
  const dispatch = useDispatch();
  const { userIsAuthorized } = useSelector(state => state.visits);
  const { t } = useTranslation();

  const handleKeycloakEvent = async event => {
    if (event === "onAuthSuccess") {
      dispatch(initialize(keycloak));
    }
  };

  if (!userIsAuthorized)
    return (
      <Result status="403" title={t("unauthorized-title")} subTitle={t("unauthorized-subtitle")} />
    );

  return (
    <Switch>
      <Route path="/">
        <ReactKeycloakProvider
          authClient={keycloak}
          onEvent={handleKeycloakEvent}
          initOptions={{
            onLoad: "check-sso",
            flow: "standard",
            checkLoginIframe: false,
            redirectUri: `${process.env.REACT_APP_DWM_URL}/api/redirectAuth?appId=${process.env.REACT_APP_ID}&siteId=${process.env.REACT_APP_SITE_ID}&type=${process.env.REACT_APP_TYPE}`,
          }}
          loginOptions={{ scope: "offline_access" }}
        >
          <HomeSwitch />
        </ReactKeycloakProvider>
      </Route>
    </Switch>
  );
};

export default Routes;
